<template>
  <div class="hero-wrapper d-flex align-items-center justify-content-center text-center">
    <div
      id="id-hero-logo-landing"
      class="hide d-flex flex-column align-items-center"
    >
      <div class="app-logo-wrapper d-flex align-items-center justify-content-center">
        <img
          class="app-logo"
          :src="agencyLogo"
          alt="Convey911 Logo"
        />
      </div>
      <div
        v-if="$auth.isAuthenticated && currentUser && currentUser.agencies && currentUser.agencies.length === 0"
        class="text-danger text-center alert-container"
        role="alert"
      >
        <div class="bg-white border">
          <h4 class="alert-heading alert-light-danger p-2 text-dark">
            You have not been assigned to an agency!
          </h4>
          <p class="pr-5 pl-5 pt-3 pb-3 text-dark">
            If you're logging in under your agency email you may need to contact your administrator and request to have your account added.
            <br /><br />
            Once you've been added to the agency you'll need to <a href="#" @click.prevent="$auth.logout()">log out</a> and log back in to stop seeing this message. 
          </p>
        </div>
      </div>
      <div
        v-if="agencyModules.length > 0"
        class="d-flex flex-wrap align-items-center justify-content-center gap-4"
      >
        <div
          v-for="agencyModule in agencyModules"
          :key="agencyModule.name"
          class="agency-module-item border bg-white-custom d-flex flex-column align-items-center gap-3"
          @click="selectModule(agencyModule)"
        >
          <div class="agency-module-item--logo">
            <svg
              v-if="agencyModule.setting === 'core:communicatorEnabled'"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_779_48799)">
                <path
                  d="M5.31199 4.56604C4.18999 5.68504 -0.715006 12.681 3.52299 16.918C7.75899 21.156 14.753 16.25 15.877 15.129C16.998 14.01 15.542 10.734 12.625 7.81704C9.70599 4.89804 6.43399 3.44104 5.31199 4.56604ZM14.576 14.156C14.244 14.484 11.681 13.699 9.21199 11.228C6.74499 8.75904 5.95599 6.19504 6.28799 5.86504C6.61599 5.53304 9.18199 6.32204 11.648 8.79104C14.119 11.258 14.906 13.824 14.576 14.156ZM15.434 5.98204L17.338 4.07604C17.5255 3.88853 17.6308 3.63421 17.6308 3.36904C17.6308 3.10386 17.5255 2.84955 17.338 2.66204C17.1505 2.47453 16.8962 2.36919 16.631 2.36919C16.3658 2.36919 16.1115 2.47453 15.924 2.66204L14.02 4.56804C13.8325 4.75555 13.7271 5.00986 13.7271 5.27504C13.7271 5.40634 13.753 5.53636 13.8033 5.65766C13.8535 5.77897 13.9271 5.88919 14.02 5.98204C14.1128 6.07488 14.2231 6.14853 14.3444 6.19878C14.4657 6.24903 14.5957 6.27489 14.727 6.27489C14.9922 6.27489 15.2465 6.16955 15.434 5.98204ZM11.124 3.80004C11.2388 3.86387 11.365 3.90446 11.4955 3.9195C11.6259 3.93455 11.7581 3.92375 11.8844 3.88772C12.0106 3.85169 12.1286 3.79114 12.2315 3.70952C12.3344 3.6279 12.4202 3.52682 12.484 3.41204L13.571 1.48604C13.6999 1.25424 13.7314 0.98073 13.6587 0.725681C13.5859 0.470631 13.4148 0.254933 13.183 0.126038C12.9512 -0.00285715 12.6777 -0.0343913 12.4226 0.0383728C12.1676 0.111137 11.9519 0.282239 11.823 0.514038L10.736 2.44004C10.6722 2.55481 10.6316 2.68103 10.6165 2.8115C10.6015 2.94196 10.6123 3.07411 10.6483 3.2004C10.6843 3.32669 10.7449 3.44464 10.8265 3.54753C10.9081 3.65042 11.0092 3.73622 11.124 3.80004ZM19.872 6.81604C19.8083 6.70116 19.7225 6.59998 19.6196 6.51829C19.5168 6.4366 19.3988 6.376 19.2725 6.33996C19.1461 6.30392 19.014 6.29315 18.8835 6.30826C18.753 6.32338 18.6267 6.36408 18.512 6.42804L16.572 7.48904C16.4572 7.55286 16.3561 7.63866 16.2745 7.74155C16.1929 7.84444 16.1324 7.96239 16.0963 8.08868C16.0603 8.21497 16.0495 8.34712 16.0645 8.47758C16.0796 8.60804 16.1202 8.73426 16.184 8.84904C16.2478 8.96381 16.3336 9.06489 16.4365 9.14651C16.5394 9.22812 16.6573 9.28867 16.7836 9.3247C16.9099 9.36073 17.0421 9.37153 17.1725 9.35649C17.303 9.34145 17.4292 9.30086 17.544 9.23704L19.484 8.17604C19.5988 8.11222 19.6999 8.02642 19.7815 7.92353C19.8631 7.82064 19.9236 7.70269 19.9597 7.5764C19.9957 7.45011 20.0065 7.31796 19.9915 7.1875C19.9764 7.05703 19.9358 6.93081 19.872 6.81604Z"
                  fill="#5B5D60"
                />
              </g>
              <defs>
                <clipPath id="clip0_779_48799">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <svg
              v-if="agencyModule.setting === 'core:alertEnabled'"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 2C8.41832 1.99994 6.8721 2.46874 5.55676 3.34717C4.24142 4.22559 3.21599 5.47421 2.61005 6.93523C2.00411 8.39625 1.84485 10.0041 2.15241 11.5556C2.45997 13.1071 3.22054 14.5326 4.33801 15.652C4.43079 15.745 4.50435 15.8553 4.55448 15.9767C4.60462 16.0981 4.63035 16.2282 4.63021 16.3596C4.63007 16.4909 4.60406 16.6209 4.55367 16.7422C4.50328 16.8635 4.42949 16.9737 4.33651 17.0665C4.24353 17.1593 4.13319 17.2328 4.01179 17.283C3.89039 17.3331 3.7603 17.3588 3.62895 17.3587C3.4976 17.3586 3.36756 17.3326 3.24627 17.2822C3.12497 17.2318 3.01479 17.158 2.92201 17.065C1.99407 16.1376 1.2583 15.0361 0.756885 13.8237C0.255468 12.6114 -0.00173899 11.312 8.8485e-06 10C8.8485e-06 4.477 4.47701 0 10 0C15.523 0 20 4.477 20 10C20 10.3247 19.9847 10.645 19.954 10.961C19.154 10.7 18.466 10.194 17.997 9.777C17.9389 7.69467 17.0709 5.71712 15.5775 4.26481C14.0841 2.81249 12.0831 1.99997 10 2ZM15.3 9.487C15.483 9.305 15.7 9.174 15.932 9.094C15.7018 7.60008 14.9163 6.24805 13.7325 5.30814C12.5488 4.36822 11.0539 3.90966 9.54665 4.02411C8.03944 4.13855 6.63093 4.81756 5.60263 5.92544C4.57433 7.03332 4.00199 8.48845 4.00001 10C4.00001 11.657 4.67301 13.158 5.75701 14.243C5.94465 14.4306 6.19915 14.5361 6.46451 14.5361C6.72987 14.5361 6.98437 14.4306 7.17201 14.243C7.35965 14.0554 7.46507 13.8009 7.46507 13.5355C7.46507 13.2701 7.35965 13.0156 7.17201 12.828C6.69092 12.3468 6.34055 11.7508 6.15403 11.0964C5.96751 10.442 5.95101 9.75087 6.10609 9.08832C6.26117 8.42578 6.5827 7.81375 7.04028 7.31012C7.49785 6.8065 8.07634 6.42793 8.72102 6.21022C9.36571 5.99251 10.0553 5.94286 10.7245 6.06596C11.3937 6.18907 12.0205 6.48086 12.5455 6.91374C13.0705 7.34662 13.4764 7.90627 13.7248 8.53976C13.9732 9.17325 14.0559 9.85964 13.965 10.534C14.4508 10.2404 14.8991 9.88884 15.3 9.487ZM10 8C9.46958 8 8.96087 8.21071 8.5858 8.58579C8.21072 8.96086 8.00001 9.46957 8.00001 10C8.00001 10.5304 8.21072 11.0391 8.5858 11.4142C8.96087 11.7893 9.46958 12 10 12C10.5304 12 11.0391 11.7893 11.4142 11.4142C11.7893 11.0391 12 10.5304 12 10C12 9.46957 11.7893 8.96086 11.4142 8.58579C11.0391 8.21071 10.5304 8 10 8ZM16.99 10.194C17.642 10.845 18.897 11.88 20.439 12.093C20.747 12.135 21 12.378 21 12.682V15.52C21 19.336 17.42 20.721 16.647 20.976C16.552 21.0079 16.4491 21.0079 16.354 20.976C15.58 20.721 12 19.336 12 15.52V12.682C12 12.378 12.253 12.135 12.561 12.092C14.103 11.88 15.358 10.845 16.011 10.194C16.1435 10.0693 16.3186 9.99979 16.5005 9.99979C16.6825 9.99979 16.8575 10.0693 16.99 10.194Z"
                fill="#5B5D60"
              />
            </svg>
            <svg
              v-if="agencyModule.setting === 'core:connectEnabled'"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.76083 16.2392C5.85416 18.2326 8.34666 17.4351 9.34416 16.6276C9.85916 16.2101 10.0917 15.9401 10.2908 15.7401C10.9883 15.0926 10.9442 14.4442 10.4908 13.9259C10.3083 13.7184 9.14416 12.6001 8.0275 11.4534C7.44916 10.8751 7.05083 10.4667 6.70916 10.1367C6.25333 9.68175 5.85416 9.16008 5.25583 9.17508C4.7075 9.17508 4.30916 9.65842 3.81 10.1576C3.23666 10.7309 2.81333 11.4534 2.66416 12.1017C2.215 13.9959 2.91333 15.3417 3.76083 16.2392ZM3.76083 16.2392L1.66666 18.3326M16.2392 3.76258C14.145 1.76758 11.6608 2.57925 10.6642 3.38758C10.1475 3.80591 9.91583 4.07591 9.71583 4.27591C9.01833 4.92425 9.0625 5.57258 9.51666 6.09091C9.58166 6.16591 9.775 6.35758 10.0458 6.62758M16.2392 3.76258C17.0867 4.66008 17.7942 6.02091 17.345 7.91675C17.195 8.56508 16.7717 9.28758 16.1983 9.86175C15.7 10.3601 15.3008 10.8442 14.7525 10.8442C14.1542 10.8592 13.8442 10.4259 13.3867 9.97092M16.2392 3.76258L18.3333 1.66675M10.0458 6.62758C10.53 7.10675 11.265 7.82925 11.98 8.56425C12.5583 9.14258 13.045 9.64091 13.3867 9.97008L12.085 11.2401M10.0458 6.62758L8.76 7.92092"
                stroke="#5B5D60"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="agency-module-item--name">
            <h4 class="mb-0">
              {{ agencyModule.name }}
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";

export default {
  name: "Hero",
  data() {
    return {
      heroLogo: this.agencyLogo
    };
  },
  computed: {
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("agency", ["agencySettings", "currentAgency", "agencyLogo", "agencyModules"])
  },
  watch: {
    currentAgency: function(agencyAfter, agencyBefore) {
      const $ = window.$;
      if ((!agencyBefore && agencyAfter) || (agencyBefore && agencyBefore.agency_id && agencyBefore.agency_id != agencyAfter.agency_id)) {
        if (this.agencySettings.agencyLogo)
          this.heroLogo = this.agencySettings.agencyLogo;
      }

      window.setTimeout(function() {
        $("#id-hero-logo-landing").fadeIn("slow");
      }, 750);
    },
  },
  created() {
    const $ = window.$;

    if (this.agencyLogo)
      this.heroLogo = this.agencyLogo;
    else if (this.$cookie.get("x-agency-logo"))
      this.heroLogo = this.$cookie.get("x-agency-logo");

    window.setTimeout(function() {
      $("#id-hero-logo-landing").fadeIn("slow");
    }, 750);
  },
  methods: {
    selectModule(module) {
      if (module) {
        this.$store.commit('agency/setSelectedAgencyModule', module);
        this.$router.push({ name: module.routeName }).catch(() => {});
      }
    }
  },
};
</script>

<style lang="scss">
.hero-wrapper {
  width: 100%;
  .fade {
    -webkit-transition-duration: 5s; /* Safari */
    transition-duration: 5s;
  }
  .alert-container {
    max-width: 800px;
  }
  .app-logo-wrapper {
    max-width: 95%;
    margin-bottom: 4rem;
    max-height: 50vh;
    overflow: hidden;

    .app-logo {
      width: 100%;
      height: 100%;
      max-width: fit-content;
      object-fit: cover;
      object-position: middle;
    }
  }
  .agency-module-item {
    width: 280px;
    cursor: pointer;
    padding: 1rem;
    border-radius: 8px;
    transition: transform 150 ease-in-out;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 0%), 0 6px 20px 0 rgb(0 0 0 / 12%);

    &:hover {
      transform: scale(1.1);
    }

    &--logo {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 80px;
      svg {
        transform: scale(3);
      }
    }
  }
}
</style>
